module.exports = __webpack_public_path__ + "static/media/PC-banner2.b94b1ede.png";